import { SideSheetProvider } from '@circlefin/side-sheet-router'

import { SideSheetRouteListener } from '../SideSheetRouteListener/SideSheetRouteListener'

export const SideSheetNavigator: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <SideSheetProvider data-testid="side-sheet-provider">
      {children}
      <SideSheetRouteListener />
    </SideSheetProvider>
  )
}
